import React, {FunctionComponent} from 'react';
import {StrapiImageData} from "../../../interfaces/strapi/strapiImage.interface";

const styles = require('./iconBox.component.scss');

export interface IconBoxProps {
    iconImage: StrapiImageData;
    iconTitle: string;
    iconSubTitle: string;

}

export const IconBox: FunctionComponent<IconBoxProps> = props => {
    const {iconImage, iconTitle, iconSubTitle} = props;

    return (
        <div className={styles.iconBox}>
            <img className={styles.iconImage} src={iconImage?.url} alt=""/>
            <div className={styles.iconBoxTitle}>{iconTitle}</div>
            <div className={styles.iconBoxSubTitle}>{iconSubTitle}</div>
        </div>
    );
}